import Blogs from '../page/blogs'
import DetailBlog from '../page/blogs/detail'
import FAQ from '../page/faq'
import HireProgress from '../page/hireProgress'
import ProfilePage from '../page/profile'
import Home from '../page/home'
import Raising from '../page/raising'
import Portal from '../page/portal'
import Teams from '../page/teams'
import LoginPage from '../page/login'
import Assessment from '../page/assessment'
import LogicAssessment from '../page/assessment/section'
import QuestionsPage from '../page/assessment/questions'
import SuccessPage from '../page/assessment/success'
import MyApplicationPage from '../page/myApplication'

export const appRoutes = [
  { path: '', useModule: <Home />, title: 'Home | SOPRA Portal' },
  {
    path: 'raising',
    useModule: <Raising />,
    title: 'Raising STAR | SOPRA Portal',
  },
  {
    path: 'step/hiring',
    useModule: <HireProgress />,
    title: 'Step Hiring | SOPRA Portal',
  },
  {
    path: 'portal',
    useModule: <Portal />,
    title: 'Job Explore | SOPRA Portal',
  },
  { path: 'teams', useModule: <Teams />, title: 'SOPRA Teams | SOPRA Portal' },
  { path: 'blogs', useModule: <Blogs />, title: 'Blogs | SOPRA Portal' },
  {
    path: 'blogs/detail',
    useModule: <DetailBlog />,
    title: 'Detail Blogs | SOPRA Portal',
  },
  { path: 'faq', useModule: <FAQ />, title: 'FAQ | SOPRA Portal' },
  {
    path: 'profile',
    useModule: <ProfilePage />,
    title: 'Profile | SOPRA Portal',
  },
  {
    path: 'my-application',
    useModule: <MyApplicationPage />,
    title: 'My Application | SOPRA Portal',
  },
  { path: 'login', useModule: <LoginPage />, title: 'Login | SOPRA Portal' },
  {
    path: 'assessment',
    useModule: <Assessment />,
    title: 'Assessment | SOPRA Portal',
  },
  {
    path: 'assessment/section-page',
    useModule: <LogicAssessment />,
    title: 'Assessment | SOPRA Portal',
  },
  {
    path: 'assessment/question',
    useModule: <QuestionsPage />,
    title: 'Assessment | SOPRA Portal',
  },
  {
    path: 'assessment/submitted',
    useModule: <SuccessPage />,
    title: 'Assessment | SOPRA Portal',
  },
]

export const navList = [
  { label: 'life_at_sopra', path: '', show: true },
  { label: 'raising_star', path: 'raising', show: true },
  { label: 'how_we_hire', path: 'step/hiring', show: true },
  { label: 'teams', path: 'teams', show: true },
  { label: 'blogs', path: 'blogs', show: true },
  { label: 'faq', path: 'faq', show: true },
]
